(function(){
  var drawer=document.getElementById('lilyDrawer');
  var overlay=document.getElementById('lilyOverlay');
  if(overlay && overlay.parentNode!==document.body) document.body.appendChild(overlay);
  if(drawer && drawer.parentNode!==document.body) document.body.appendChild(drawer);
  var itemsEl=drawer?drawer.querySelector('#lilyCartItems'):null;
  var emptyEl=drawer?drawer.querySelector('#lilyCartEmpty'):null;
  var footEl=drawer?drawer.querySelector('#lilyCartFoot'):null;
  function money(c){ return '$'+(c/100).toFixed(2); }
  function isGift(it){ return it.final_price===0; }
  function onCartPage(){ return !!document.querySelector('.lcartpage'); }
  function open(){ if(drawer){ drawer.classList.add('open'); if(overlay) overlay.classList.add('open'); document.body.style.overflow='hidden'; } }
  function close(){ if(drawer){ drawer.classList.remove('open'); if(overlay) overlay.classList.remove('open'); document.body.style.overflow=''; } }
  function reconcileGifts(cart){
    var shaverPid=window.LILY_SHAVER_PID, gifts=window.LILY_GIFTS||[];
    if(!shaverPid||!gifts.length||!cart||!cart.items) return Promise.resolve(cart);
    var shaverQty=0;
    cart.items.forEach(function(it){ if(String(it.product_id)===String(shaverPid)) shaverQty+=it.quantity; });
    var ops=[];
    gifts.forEach(function(g){
      var line=null;
      cart.items.forEach(function(it){ if(String(it.variant_id)===String(g.id)) line=it; });
      var desired = shaverQty>=g.min ? 1 : 0;
      var cur = line?line.quantity:0;
      if(desired!==cur){ if(line){ ops.push({key:line.key,qty:desired}); } else if(desired>0){ ops.push({addId:g.id,qty:desired}); } }
    });
    if(!ops.length) return Promise.resolve(cart);
    var onCart=onCartPage();
    var chain=Promise.resolve();
    ops.forEach(function(op){ chain=chain.then(function(){
      if(op.key!==undefined){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:op.key,quantity:op.qty})}); }
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(op.addId,10),quantity:op.qty}]})});
    }); });
    return chain.then(function(){ if(onCart){ location.reload(); return null; } return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); });
  }
  function render(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(e){ e.textContent=cart.item_count; e.style.display=cart.item_count>0?'':'none'; });
    document.querySelectorAll('[data-cart-subtotal]').forEach(function(e){ e.textContent=money(cart.total_price); });
    var orig=document.querySelector('[data-cart-original]');
    if(orig){ if(cart.total_discount>0){ orig.style.display=''; orig.textContent=money(cart.original_total_price); } else { orig.style.display='none'; orig.textContent=''; } }
    var dRow=document.querySelector('[data-cart-discount-row]');
    if(dRow){
      if(cart.total_discount>0){
        dRow.style.display='';
        var title='Discount';
        try{ title=cart.items[0].line_level_discount_allocations[0].discount_application.title; }catch(e){}
        var tEl=dRow.querySelector('[data-cart-discount-title]'); if(tEl) tEl.textContent=title;
        var aEl=dRow.querySelector('[data-cart-discount-amt]'); if(aEl) aEl.textContent='-'+money(cart.total_discount);
      } else { dRow.style.display='none'; }
    }
    if(!itemsEl) return;
    if(cart.item_count===0){ if(emptyEl){ emptyEl.textContent='Your bag is empty.'; emptyEl.style.display=''; } if(footEl) footEl.style.display='none'; itemsEl.innerHTML=''; return; }
    if(emptyEl) emptyEl.style.display='none'; if(footEl) footEl.style.display='';
    itemsEl.innerHTML=cart.items.map(function(it){
      var img=it.image?('<img src="'+it.image+'" alt="" class="ldi__img">'):'<div class="ldi__img"></div>';
      if(isGift(it)){
        return '<div class="ldi ldi--gift" data-key="'+it.key+'">'+img+
          '<div class="ldi__body"><div class="ldi__title">'+it.product_title+'</div>'+
          '<div class="ldi__opt">Free bonus · qty '+it.quantity+'</div>'+
          '<div class="ldi__row"><span class="ldi__giftbadge">Included free</span><span class="ldi__price" style="color:var(--l-wine)">Free</span></div></div></div>';
      }
      return '<div class="ldi" data-key="'+it.key+'">'+img+
        '<div class="ldi__body"><div class="ldi__title">'+it.product_title+'</div>'+
        (it.variant_title && it.variant_title!=='Default Title'?'<div class="ldi__opt">'+it.variant_title+'</div>':'')+
        '<div class="ldi__row"><div class="ldi__qty"><button type="button" data-dec aria-label="Decrease">−</button><span>'+it.quantity+'</span><button type="button" data-inc aria-label="Increase">+</button></div>'+
        '<span class="ldi__price">'+money(it.final_line_price)+'</span></div></div>'+
        '<button class="ldi__rm" type="button" data-rm aria-label="Remove">×</button></div>';
    }).join('');
  }
  function refresh(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ return reconcileGifts(c); }).then(function(c){ render(c); return c; }); }
  function post(items){
    if(!items||!items.length){ open(); return Promise.resolve(); }
    open();
    if(emptyEl){ emptyEl.textContent='Adding to your bag…'; emptyEl.style.display=''; }
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
      .then(function(res){ if(!res.ok){ if(emptyEl){ emptyEl.textContent=(res.d&&res.d.description)||'Sorry, that could not be added right now.'; emptyEl.style.display=''; } if(footEl) footEl.style.display='none'; return; } return refresh(); });
  }
  function add(id,qty){ return post(id?[{id:parseInt(id,10),quantity:qty||1}]:[]); }
  function addItems(items){
    var clean=(items||[]).filter(function(i){ return i && i.id; }).map(function(i){ return {id:parseInt(i.id,10),quantity:i.quantity||1}; });
    return post(clean);
  }
  function change(key,qty){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(c){ return reconcileGifts(c); }).then(function(c){ render(c); return c; }); }
  if(itemsEl){ itemsEl.addEventListener('click',function(e){
    var row=e.target.closest('.ldi'); if(!row) return;
    if(row.classList.contains('ldi--gift')) return;
    var key=row.dataset.key; var q=parseInt(row.querySelector('.ldi__qty span').textContent,10);
    if(e.target.closest('[data-inc]')) change(key,q+1);
    else if(e.target.closest('[data-dec]')) change(key,Math.max(0,q-1));
    else if(e.target.closest('[data-rm]')) change(key,0);
  }); }
  document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click',function(e){ e.preventDefault(); refresh(); open(); }); });
  document.querySelectorAll('[data-cart-close]').forEach(function(b){ b.addEventListener('click',close); });
  if(overlay) overlay.addEventListener('click',close);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  window.LilyCart={open:open,close:close,add:add,addItems:addItems,refresh:refresh};
  refresh();
})();